import React from "react";
import { Container } from "react-bootstrap";
import EventSliderCard from "../EventSliderCard/EventSliderCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EventSlider.css";

interface EventSlider {
  title: string;
  type: string;
  buttonText: string;
  data: any[] | undefined;
}

const EventSlider = (data: EventSlider) => {
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <div
      style={{
        paddingTop: "100px",
        paddingBottom: "100px",
        backgroundColor: "#000000"
      }}
      className="eventSlider"
    >
      <Container>
        <div style={{ borderBottom: "1px solid #444", margin: "0 0 30px" }}>
          <h2
            className="section-title-4"
            style={{
              fontSize: "24px",
              color: "#ffffff",
              margin: "0",
              fontWeight: "bold",
              padding: "0 0 15px",
              textTransform: "capitalize"
            }}
          >
            {data?.title}
          </h2>
        </div>
        <Slider {...settings}>
          {data?.data?.map((event, index) => (
            <EventSliderCard
              key={index}
              title={event.name}
              imageUrl={event?.images[0]?.url}
              date={event.date}
              league={event.league}
              event={false}
              url={`/${data.type}/${event?.uuid}`}
              buttonText={data.buttonText}
            />
          ))}
        </Slider>
      </Container>
    </div>
  );
};

export default EventSlider;
